import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { VariedadService } from '../variedad.service';
import { FilterSearchingTVariedadViewModel, VariedadItemResultsViewModel } from '../variedad.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { DialogSelectionMode } from 'src/app/components/_campanias/types/enum';

@Component({
    selector: 'app-variedad-buscador',
    templateUrl: './variedad-buscador.component.html',
    styleUrls: ['./variedad-buscador.component.scss'],
})
export class VariedadBuscadorComponent extends ComponentBase implements OnInit {
    @Input() dialogMode = false;
    @Input() selectionMode: DialogSelectionMode = DialogSelectionMode.Single;
    @Output() selectVariedad = new EventEmitter<any>();
    @Output() undoSelectVariedad = new EventEmitter<any>();

    visibilitySpinner = false;
    searching = false;
    result: VariedadItemResultsViewModel | null;
    payload?: FilterSearchingTVariedadViewModel;

    grupos: Tc[];
    formas: Tc[];

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private variedadService: VariedadService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.getGrupos();
        this.recoverLastSearch();
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.variedadService.getLastSearch();
    }

    private getGrupos(): void {
        this.globalService.getGrupos().subscribe((grupos: Tc[]) => {
            this.grupos = grupos;
        });
    }

    /**
     * Respond to the action of searching on variedad-filter.
     * It will send the filter to the backend and set the response.
     * @param payload FilterSearchingTVariedadViewModel
     * @return void
     */
    onSearch(payload: FilterSearchingTVariedadViewModel): void {
        this.payload = { ...payload } as FilterSearchingTVariedadViewModel; // To keep a copy to be used in the lazy search (paginator)
        if (!payload) {
            return;
        }
        this.variedadService.getVariedades(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingTVariedadViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.formas = [];
        this.result = null;
        this.variedadService.clearLastSearch();
    }

    /**
     * Invoked when the user selects a group in the filter
     * @param grupoId number
     * @return void
     */
    onGroupSelected(grupoId: number): void {
        this.globalService.getFormasByGrupo(grupoId).subscribe((formas: Tc[]) => {
            this.formas = formas;
        });
    }

    /**
     * Variedad seleccionada en el listado
     * @param $event { selection: rowData, dblclick: dblclick }
     */
    onSelectVariedad($event: any): void {
        this.selectVariedad.emit($event);
    }

    /**
     * Se elimina variedad de la selección en el listado
     * @param $event rowData
     */
    onUndoSelect($event: any): void {
        this.undoSelectVariedad.emit($event);
    }

    get dialogSelectionMode(): string {
        return this.selectionMode || DialogSelectionMode.Single;
    }
}
